<template>
  <div class="rightBar">
    <div v-if='type==1'>
        <div class="ReactModal__Content ReactModal__Content--after-open SidePanel_container_iLZTuc" tabindex="-1" role="dialog" aria-label="sidePanel">
          <div class="SidePanel_header_2aul_9">
            <div class="SidePanel_title_3lP_QU">开场提示</div>
            <div class="SidePanel_close_3b1ufR close" @click='close'>
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAyUlEQVQ4y63UwQ3DIAwFUF9YInNkF1bINu2hc3SPrsAiGITiHtKQRDHwLZUbhycs+B8iIko+eQKXOH7IVLfJc+GCcXH8jsLhx5PnEiUKwjcapfIdj/lBlbP7XKUYb9Ix79I+H9I2h6jOYXrnJnrjHxO9cjO9cxMlEncaeM2LiR7XhFZGe9fVxK+Pkxe0cWok4MLqkYB4O01D3g9il48z3ORY/FWON0fh/MQzfOZ5JiKZOODxr7/8ax984oA3J3kulW7cUro80z/WFy2VcKz02EA2AAAAAElFTkSuQmCC" class="SidePanel_imgClose_2a2S-Y"></div>
              </div>
              <div class="SidePanel_body_1nZuJv">
                <div class="SidePanel_bodyContainer_1iszVS">
                  <div style="position: relative; overflow: hidden; width: 100%; height: 100%;">
                    <div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;">
                      <div class="SidePanelStartImage_group_2i-4Oa SidePanelStartImage_pc_2tEyQ9">
                        <div class="SidePanelStartImage_title_1NJT_P">桌面端</div><div class="ContentBox_box_18qEQ3 SidePanelStartImage_imgContainer_107-s9">
                          <img src="https://ssl-static.720static.com/imgs/32j4Y2lC5oDk.png" class="SidePanelStartImage_imgDefault_3xWDpa"></div>
                          <div class="SidePanelStartImage_row_153qEM SidePanelStartImage_footer_vgA79N">
                            <div class="SidePanelStartImage_tip_1vNm9e"><p>建议尺寸</p><p>300x300</p></div><a class="pano-button pano-button-sm pano-button-primary">选择图片</a></div></div>
                            <div class="SidePanelStartImage_group_2i-4Oa SidePanelStartImage_mobile_21eXlC">
                              <div class="SidePanelStartImage_title_1NJT_P">移动端</div>
                              <div class="ContentBox_box_18qEQ3 SidePanelStartImage_imgContainer_107-s9">
                                <img src="https://ssl-static.720static.com/imgs/1AzyG1T2bZNK.png" class="SidePanelStartImage_imgDefault_3xWDpa"></div>
                                <div class="SidePanelStartImage_row_153qEM SidePanelStartImage_footer_vgA79N">
                                  <div class="SidePanelStartImage_tip_1vNm9e"><p>建议尺寸</p><p>300x300</p></div><a class="pano-button pano-button-sm pano-button-primary">选择图片</a></div></div>
                                  <div class="SidePanelStartImage_group_2i-4Oa SidePanelStartImage_duration_3DGQuL">
                                    <div class="SidePanelStartImage_row_153qEM SidePanelStartImage_title_1NJT_P"><span>显示时间<span class="SidePanelStartImage_tipTime_2YPTeC">（0秒不显示）</span></span><span>5秒</span></div>
                                    <div class="rc-slider"><div class="rc-slider-rail" style="background-color: rgb(43, 43, 43); border: 1px solid rgb(67, 67, 67); border-radius: 0px;"></div>
                                    <div class="rc-slider-track" style="background-color: rgb(65, 121, 249); border: 1px solid rgb(67, 67, 67); border-radius: 0px; left: 0%; width: 50%;"></div>
                                    <div class="rc-slider-step"></div><div tabindex="0" class="rc-slider-handle" role="slider" aria-valuemin="0" aria-valuemax="10" aria-valuenow="5" aria-disabled="false" style="border: 1px solid rgb(255, 255, 255); background-color: rgb(223, 223, 223); left: 50%;"></div>
                                    <div class="rc-slider-mark"></div></div>
                                    <div class="SidePanelStartImage_row_153qEM SidePanelStartImage_sec_2Ji51Q"><span>0秒</span><span>10秒</span></div></div></div>
                                    <div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
                                      <div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div>
                                      <div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
                                        <div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
                                        <div class="SidePanel_footer_3WAcEI"><a class="pano-button pano-button-md pano-button-primary SidePanelStartImage_btn_1afHfU">完 成</a></div></div>
    </div>
    <div v-if='type==2'>
      <div class="ReactModal__Content ReactModal__Content--after-open SidePanel_container_iLZTuc" tabindex="-1" role="dialog" aria-label="sidePanel">
        <div class="SidePanel_header_2aul_9">
          <div class="SidePanel_title_3lP_QU">开场封面<a href="https://bbs2.720yun.com/article?id=231" target="_blank" rel="noopener noreferrer">
          <img class="HelpIcon_root_WFV-sl SidePanel_help_3netw3" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAA81BMVEUAAACzs7Orq6urq6urq6urq6uqqqqqqqqrq6uqqqqurq6qqqqqqqqsrKyqqqqrq6utra2srKysrKyurq6qqqosLCympqZra2ucnJxDQ0N+fn5lZWWhoaF/f39xcXGSkpI0NDRvb2+kpKSZmZmlpaWdnZ2bm5s4ODhGRkaoqKinp6dAQEA5OTlPT0+Dg4N0dHSKioo6OjpFRUU1NTV3d3eTk5OBgYFnZ2cxMTGJiYmWlpaLi4tYWFgyMjJISEgtLS0zMzOEhIR5eXk/Pz9ERERMTExdXV2UlJRNTU1ubm49PT2YmJh4eHienp5RUVFZWVlOTk58rGCDAAAAFHRSTlMACrxto/4GivjhFsQ/WR77HyUrJiy7ftYAAAGQSURBVHhenZTlbuRAEAZtL1M2zlablyEIh8zM8P5Pc9nb0XTGuZOlq9+lac3X4Ln4YX8w6Ie+90/2asEQAIZBbe+vyn69gUKjvn9DabbaAMvxJM8n4yVAu9V0nW4PKOJUDGlcAL3udeegA9F8JorM5hF0DtTpdmB9JCWO1tCxbzV7MD2UG5xNodc0UgvWxkkvvifj1FpraJm/t4lMrZ/HANEzWzGivUuiDvOdc7oCgMVtMcyh/ifnBoX51yXcenfnKdyzfyxobLOvQSw7EhZX+t0VUzFIDLUrKYDUSBGPt+59FlZKIfA8f8hSDA94KCKPTngiliVD3xtBJobnL16KvHoNb1TKIPT6MBFF4hUcv1VpAn1vALko7wE+iJLDoCzF8PGTlKRyuc9ga2m5EDL3pZkjjSE0EVi+fP1mBY1AwyyjYWpbymhbbIMt50nyQ8RtsI6KIYFExB0VHTqVNuIOnY6vltv8csa3YhEOdREqVqpiOU/c5axec/dgZNuDkenBqDw9/3HEFH+0PYcj3xV+A578V+4+4HKVAAAAAElFTkSuQmCC" alt=""></a></div>
          <div class="SidePanel_close_3b1ufR">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAyUlEQVQ4y63UwQ3DIAwFUF9YInNkF1bINu2hc3SPrsAiGITiHtKQRDHwLZUbhycs+B8iIko+eQKXOH7IVLfJc+GCcXH8jsLhx5PnEiUKwjcapfIdj/lBlbP7XKUYb9Ix79I+H9I2h6jOYXrnJnrjHxO9cjO9cxMlEncaeM2LiR7XhFZGe9fVxK+Pkxe0cWok4MLqkYB4O01D3g9il48z3ORY/FWON0fh/MQzfOZ5JiKZOODxr7/8ax984oA3J3kulW7cUro80z/WFy2VcKz02EA2AAAAAElFTkSuQmCC" class="SidePanel_imgClose_2a2S-Y"></div></div>
            <div class="SidePanel_body_1nZuJv">
              <div class="SidePanel_bodyContainer_1iszVS">
                <div style="position: relative; overflow: hidden; width: 100%; height: 100%;">
                  <div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;">
                    <div class="BusinessFeature_container_3iMptY">
                      <div class="BusinessFeature_text_3aU27K">专业版功能，开通即可使用</div>
                      <a class="pano-button pano-button-sm pano-button-important BusinessFeature_btn_2eZ2Lp" href="/vip/views" target="_blank">开通专业版</a>
                      <a href="https://bbs2.720yun.com/article?id=231" class="BusinessFeature_url_13slbU" target="_blank" rel="noopener noreferrer">查看案例</a></div></div>
                      <div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
                        <div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div>
                        <div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
                          <div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
                          <div class="SidePanel_footer_3WAcEI"><a class="pano-button pano-button-md pano-button-primary SidePanelEnterCover_btn_1hKtcG">完 成</a></div></div>
    </div>
    <div v-if='type==3'>
      <div class="ReactModal__Content ReactModal__Content--after-open SidePanel_container_iLZTuc" tabindex="-1" role="dialog" aria-label="sidePanel">
        <div class="SidePanel_header_2aul_9">
          <div class="SidePanel_title_3lP_QU">开场动画<a href="https://bbs2.720yun.com/article?id=573" target="_blank" rel="noopener noreferrer">
          <img class="HelpIcon_root_WFV-sl SidePanel_help_3netw3" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAA81BMVEUAAACzs7Orq6urq6urq6urq6uqqqqqqqqrq6uqqqqurq6qqqqqqqqsrKyqqqqrq6utra2srKysrKyurq6qqqosLCympqZra2ucnJxDQ0N+fn5lZWWhoaF/f39xcXGSkpI0NDRvb2+kpKSZmZmlpaWdnZ2bm5s4ODhGRkaoqKinp6dAQEA5OTlPT0+Dg4N0dHSKioo6OjpFRUU1NTV3d3eTk5OBgYFnZ2cxMTGJiYmWlpaLi4tYWFgyMjJISEgtLS0zMzOEhIR5eXk/Pz9ERERMTExdXV2UlJRNTU1ubm49PT2YmJh4eHienp5RUVFZWVlOTk58rGCDAAAAFHRSTlMACrxto/4GivjhFsQ/WR77HyUrJiy7ftYAAAGQSURBVHhenZTlbuRAEAZtL1M2zlablyEIh8zM8P5Pc9nb0XTGuZOlq9+lac3X4Ln4YX8w6Ie+90/2asEQAIZBbe+vyn69gUKjvn9DabbaAMvxJM8n4yVAu9V0nW4PKOJUDGlcAL3udeegA9F8JorM5hF0DtTpdmB9JCWO1tCxbzV7MD2UG5xNodc0UgvWxkkvvifj1FpraJm/t4lMrZ/HANEzWzGivUuiDvOdc7oCgMVtMcyh/ifnBoX51yXcenfnKdyzfyxobLOvQSw7EhZX+t0VUzFIDLUrKYDUSBGPt+59FlZKIfA8f8hSDA94KCKPTngiliVD3xtBJobnL16KvHoNb1TKIPT6MBFF4hUcv1VpAn1vALko7wE+iJLDoCzF8PGTlKRyuc9ga2m5EDL3pZkjjSE0EVi+fP1mBY1AwyyjYWpbymhbbIMt50nyQ8RtsI6KIYFExB0VHTqVNuIOnY6vltv8csa3YhEOdREqVqpiOU/c5axec/dgZNuDkenBqDw9/3HEFH+0PYcj3xV+A578V+4+4HKVAAAAAElFTkSuQmCC" alt=""></a></div>
          <div class="SidePanel_close_3b1ufR">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAyUlEQVQ4y63UwQ3DIAwFUF9YInNkF1bINu2hc3SPrsAiGITiHtKQRDHwLZUbhycs+B8iIko+eQKXOH7IVLfJc+GCcXH8jsLhx5PnEiUKwjcapfIdj/lBlbP7XKUYb9Ix79I+H9I2h6jOYXrnJnrjHxO9cjO9cxMlEncaeM2LiR7XhFZGe9fVxK+Pkxe0cWok4MLqkYB4O01D3g9il48z3ORY/FWON0fh/MQzfOZ5JiKZOODxr7/8ax984oA3J3kulW7cUro80z/WFy2VcKz02EA2AAAAAElFTkSuQmCC" class="SidePanel_imgClose_2a2S-Y"></div></div><div class="SidePanel_body_1nZuJv"><div class="SidePanel_bodyContainer_1iszVS"><div style="position: relative; overflow: hidden; width: 100%; height: 100%;"><div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;">
              <div class="SidePanelOpening_container_2qXr4D">
                <div class="SidePanelOpening_row_1Rm0Gq">小行星开场<img src="../assets/active.png" class="ToggleIcon_root_2QoX04" alt=""></div>
                <div class="SidePanelOpening_row_1Rm0Gq">水平巡游开场<img src="../assets/noactive.png" class="ToggleIcon_root_2QoX04" alt=""></div><div class="SidePanelOpening_row_1Rm0Gq">小行星巡游开场<img src="../assets/noactive.png" class="ToggleIcon_root_2QoX04" alt=""></div>
                <div class="SidePanelOpening_row_1Rm0Gq">水晶球开场<img src="../assets/noactive.png" class="ToggleIcon_root_2QoX04" alt=""></div><div class="SidePanelOpening_row_1Rm0Gq">小行星缩放开场<img src="../assets/noactive.png" class="ToggleIcon_root_2QoX04" alt=""></div></div></div>
                <div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
                  <div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div>
                  <div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
                    <div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
                    <div class="SidePanel_footer_3WAcEI"><a class="pano-button pano-button-md pano-button-primary SidePanelOpening_btn_1UUdW-">完 成</a></div></div>
    </div>
    <div v-if='type==4'>
      <div class="ReactModal__Content ReactModal__Content--after-open SidePanel_container_iLZTuc" tabindex="-1" role="dialog" aria-label="sidePanel">
        <div class="SidePanel_header_2aul_9">
          <div class="SidePanel_title_3lP_QU">界面模板</div>
          <div class="SidePanel_close_3b1ufR">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAyUlEQVQ4y63UwQ3DIAwFUF9YInNkF1bINu2hc3SPrsAiGITiHtKQRDHwLZUbhycs+B8iIko+eQKXOH7IVLfJc+GCcXH8jsLhx5PnEiUKwjcapfIdj/lBlbP7XKUYb9Ix79I+H9I2h6jOYXrnJnrjHxO9cjO9cxMlEncaeM2LiR7XhFZGe9fVxK+Pkxe0cWok4MLqkYB4O01D3g9il48z3ORY/FWON0fh/MQzfOZ5JiKZOODxr7/8ax984oA3J3kulW7cUro80z/WFy2VcKz02EA2AAAAAElFTkSuQmCC" class="SidePanel_imgClose_2a2S-Y"></div></div><div class="SidePanel_body_1nZuJv"><div class="SidePanel_bodyContainer_1iszVS"><div style="position: relative; overflow: hidden; width: 100%; height: 100%;"><div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;">
              <div style="padding-top: 30px;">
                <div class="TemplateItem__Item-iPGQLa hpwXMY">
                  <div class="block-horizontal-layout block-justify-between block-align-center" style="margin-bottom: 10px;">系统默认<div class="Checkbox_container_jYKPxJ">
                    <div class="Checkbox_checkbox_2hIu2H Checkbox_checked_3yFHX3" style="width: 14px; height: 14px;"><span class="SVGInline">
                      <svg class="SVGInline-svg" fill="#fff" style="width: 10px;height: 10px;" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg"><path d="M7.146 0l-4.36 4.39L.81 2.412 0 3.371l2.757 2.756L8 .854z" fill-rule="evenodd"></path></svg></span></div>
                      <div class="Checkbox_label_3AqBz_">启用</div></div></div><div class="TemplateItem__Container-nfaug gXNqfT">
                        <img src="https://ssl-static.720static.com/imgs/jqlIaLuNRAmC.jpg" style="width: 230px; height: 100px;">
                        <div class="TemplateItem__Cover-byPKZG hRGmwL">
                          <a class="pano-button pano-button-sm pano-button-primary" href="https://720yun.com/t/b7djzOtysw7" target="_blank">预 览</a></div></div>
                          <div class="pano-dropdown-container" role="combobox" aria-expanded="false" aria-haspopup="listbox" aria-labelledby="downshift-5-label">
                            <div class="pano-dropdown-trigger pano-dropdown-trigger-dark">
                              <div class="pano-dropdown-selected">一级导航 (缩略图)</div>
                              <svg width="7" height="12"><g fill="#aaa" fill-rule="evenodd"><path d="M3.443 0L0 4.8h7zM3.557 12L7 7.2H0z"></path></g></svg></div></div></div>
                              <div class="TemplateItem__Item-iPGQLa hpwXMY">
                                <div class="block-horizontal-layout block-justify-between block-align-center" style="margin-bottom: 10px;">清爽蓝<div class="Checkbox_container_jYKPxJ">
                                  <div class="Checkbox_checkbox_2hIu2H" style="width: 14px; height: 14px;"></div>
                                  <div class="Checkbox_label_3AqBz_">启用</div></div></div><div class="TemplateItem__Container-nfaug gXNqfT">
                                    <img src="https://ssl-static.720static.com/imgs/1F7a4una9XWi.jpg" style="width: 230px; height: 100px;">
                                    <div class="TemplateItem__Cover-byPKZG hRGmwL">
                                      <a class="pano-button pano-button-sm pano-button-primary" href="https://720yun.com/t/43bjepeOOv5" target="_blank">预 览</a></div></div></div>
                                      <div class="TemplateItem__Item-iPGQLa hpwXMY">
                                        <div class="block-horizontal-layout block-justify-between block-align-center" style="margin-bottom: 10px;">室内设计/房产<div class="Checkbox_container_jYKPxJ">
                                          <div class="Checkbox_checkbox_2hIu2H Checkbox_disabled_3iy_JQ" style="width: 14px; height: 14px;"></div>
                                          <div class="Checkbox_label_3AqBz_">启用</div></div></div><div class="TemplateItem__Container-nfaug gXNqfT">
                                            <img src="https://ssl-static.720static.com/imgs/2nJ-9ceY1Mf8.png" style="width: 230px; height: 100px;">
                                            <div class="TemplateItem__Cover-byPKZG hRGmwL"><div class="block-vertical-layout block-align-center">
                                              <div style="margin-bottom: 15px;">专业版功能，开通即可使用</div>
                                              <div><a class="pano-button pano-button-sm pano-button-primary" href="https://720yun.com/t/b3vksmq9dre" target="_blank">预 览</a>
                                              <a class="pano-button pano-button-sm pano-button-important" href="/vip" target="_blank" style="margin-left: 10px;">开 通</a></div></div></div></div></div>
                                              <div class="TemplateItem__Item-iPGQLa hpwXMY">
                                                <div class="block-horizontal-layout block-justify-between block-align-center" style="margin-bottom: 10px;">底部目录<div class="Checkbox_container_jYKPxJ">
                                                  <div class="Checkbox_checkbox_2hIu2H Checkbox_disabled_3iy_JQ" style="width: 14px; height: 14px;"></div>
                                                  <div class="Checkbox_label_3AqBz_">启用</div></div></div><div class="TemplateItem__Container-nfaug gXNqfT">
                                                    <img src="data:image/png;base64,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" style="width: 230px; height: 100px;"><div class="TemplateItem__Cover-byPKZG hRGmwL"><div class="block-vertical-layout block-align-center"><div style="margin-bottom: 15px;">专业版功能，开通即可使用</div><div><a class="pano-button pano-button-sm pano-button-primary" href="https://720yun.com/t/456jepeO5u9" target="_blank">预 览</a><a class="pano-button pano-button-sm pano-button-important" href="/vip" target="_blank" style="margin-left: 10px;">开 通</a></div></div></div></div></div><div class="TemplateItem__Item-iPGQLa hpwXMY"><div class="block-horizontal-layout block-justify-between block-align-center" style="margin-bottom: 10px;">顶部导航<div class="Checkbox_container_jYKPxJ"><div class="Checkbox_checkbox_2hIu2H Checkbox_disabled_3iy_JQ" style="width: 14px; height: 14px;"></div><div class="Checkbox_label_3AqBz_">启用</div></div></div>
                                                    <div class="TemplateItem__Container-nfaug gXNqfT">
                                                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcwAAADICAAAAABAVo74AAAPjElEQVR4Ae3a91/T19//8e8f9JSEEZCAREQ0FMEtH4tFpKIWR7Rx4AAVVLS0glpai3tTZ0tdFWkdpRbqB+wXtyIFhbAbRhhvxus65x0I2BukkWtx4ev+w8m5wY+PJO8z8v9CRw3GMUdXTLBRgWNyTMYxGcdkHJNjMo7JOCYbnTEZx2Qck2Myjsk4JuOYHJNxTMYxvT0g6eFgn092Qz8PDzj44x24Yyie8JrohT5BgBZO6fRQGf3gGq/Z3hAmGN6jmBeU2JCQyZ5VZSGCO4RztYGArr4YDpFNzfPRy8t6DeZsuywMJiJbFXx5H3DyhWivmxYxf9GKNTuO5TxuvAZBv/TwAyVqGW3cnGNPNLdrc1xtSNASIQaDu94JyYNOQPosa4DPAGRkO2ghmegLABH0/ciJuSEZDrFfnEtb4gbV1KSsY9v0UIVvPX1w7TgMi1EhofZzUs2BEG67DaTTp+gz32axtH0Cu620ExlWK3VYrUoNBhNnoxorWUNzbON9bL8BCOohlVL1x6XPtcCtHqLuwthYSk5VLFEQrvSEB9sKk0iodhLzo6/8+2IWdFU6dBUAKOoqt7ORF4DYy8/o3uWZ8+ZVNH80b+4IiVmpoJchj6R/B0PY00WCbTUAty/Vef1SDIO2uGtzQc9ms7Xp04Kerct9gZOFhfUvCwtt3YWFJ6Fa2GoxTipXVkP1olEn/0YJwK+vMagD5BNHJhitC3dRNISY2Jj9dH0cFi+DdDDnPB0A5lMq5jacBxCo3IlIySyKWLly5StnMdMoTI1pFDErgVBLRlBQkDcq1Zi1sMtWYyZTjcVKJ0hlHWkxNS/p8mzdtNNU4Qlk0IuYsbPTujrCgW+odLE+KKGJovHu/O9kLPmXbQO2JSC8dAmE/Nbc3NyWFjG05kPwPNxlMQITXtF3fmrFL4xVZlzvGAs8eDRUzJjPyHT6WcWzlp5nDyCtaz8/Blu7XkwAoPHx+ZCO+PjEUKaPT7ivBjhPH6fTDDcIhYPH1Opzu/QeasxbB0tsakx9MUlpvTHJwR5zXdwWWr5FtWGkxdxO2ZCO0z5MaK0fC+EEHURwe60PhEh6OgbDENb269igUrvFMuYbjUbz8qUY3siY0WVUPBmC4Vdq2ACvQsuMG8oHZuUGgOpbQ8UUTJn5+U1t+fm3APj+SbYf7z2lHB2EOHpLHExEunSaCicxl6vZ0ijlAhF1tciYEZX0l2n83Zrg3pi2jD6RETLmyTdJZAyKEnwx0mLeJyOkgJ5n2EbpkDxnGUVk+xwFNAXDEde51XBDKiKzjEkOIuYHPUr6tjt60fz+mg3WnqmxJBxL66mfNDGjiL4aKubKDDIBKHoBu1s/Z9+i7r36NC2AsCNHLtGDI0eO0p9HhLAJ1n+OOe34nz3H9xWLkJQXdsUqY4Y9j/6hu7R5BnpjKitD7abc7tGLmDMaL5ExlYSP8V/mk6qKGEhTnlp3QNLdbrnwzjFrbbCracMJ+gSAv+CLk7QYqhO0DO8upnVjiEnlvtwe86/ExMTqajH8JWIicxpOkAGIoFQEbIXnkSRLw7iiilnwrGvM8XX6zASe/4FeXvs7yj7Cop4zUE2nTACWYsRdMmBbZ4nTmI5nZgZRyng6ges1MqZhzbkyauy8tz1IjXmY+hUj+AJtXXNOxozP+K+MaSEqgXSdqMsPwi4iWvKuMRUL7F6S7grNBQwkPIKcqzIoAe8ulhK9SBXQG7N20aJFlZViqM2HyhFTtYlWwxAfp4oYKmZVA5layW4eMH59JeXMi41Pe0Mbe2N+u/FG6C2bd2WNHpM2XnAtpmGffQF065WMeYost5M1cTeUbDWmZkGCKvNowmp/xJMkYwYtHYExS7s0UNnq8A2tBHSZmUdFzP0ygXSR5g835jGtNt0Rkxx6Y17q0fXHDGvJM1+OUUiVO1TM7DwynTr7I9Hds2eNQAnZWUuqWyZBt3j3T0SkhO6nWxQHwcWY9tXs6XNKgYypD8MRev2Vwd9bxAz/os+bVjGE6U/T/NhMMu6mgKUj8Gv2Bi2HFE2/wUznIelFTDNdhuRu6Ro33JiNZWV/9cUMmSWUl8sxBKon5XDE1DcR0Ys5SkGs0Jrr5GvW7I4vqPsSpNikjXFReaSDflp7AmaS8MCkQyTRJbgeM2CJGvNE3rNIGROY7RV2rHQcIGLG01tW45Tt6q0tZPxagYw50hZAc7r/nATA8IRioCnpXAIhgB6JebcJwJjjlIXhxixITb1tjxl4SdXYaH8NBOCu/NgfE7+dNRsA5SqE5iFjRhymzjkot+xTJkKKrknAVdKeqpwWCHilRM+nTMD3FCm+49J1LsUMKKCOHHtMeCUFyJih3cr9jGitGnNsePjUi6Zw4aFVDD64+SpB2U3GCxUypn6kxOw+qzLgADVeTDtbpzaLaqRb+1Oz6ikfiG6mW18efkiv/IcdMy8x8YY9Zlizqru7WRUG4BNKd8SUPGJPJDiN+eFrEn4xxFOKt7VAC2BXZ9sCGXNOVXOsYwG0qY4aae18WuVKzE1E1YdCRUxEToKRdsiYCEnObaa2D2RMYVZX/WwA9xsgVfzq33KDPigtlDHbdo2QmGQXCphedVNP+TpIE+/YiLrKUtwBTM5rI7Ke9sJwY3aqApL6T/BevkSf4HprcH9M30tPO6lji/IsXegYPGZwycUtn5HJ3FnjhWS6DI/L1PIx8CtpYSjuTAA8/dfRN9nUtFNX2vhzt2FATI2+thKDmXp1kRuQQinThQyKQ0GDWVp74oHZ3KDGhLmzJRh4rMacSfugyaD9tEPENPXsGYEH7brp3ugzJiRUi15uUyZgeGRMqALK22jyIDHzuhejP6ZHZ/GBhR5wugCS4mhLe00YgEsUo/n9gRGXmqgcgO+jAo360Iybd24cEFZNuRgQ8w7RRQwtpItUTd4ooAEKoDJ96Vfxmv6AsJKma6s720tqPDC+i8j0ftyazPw5FnZHT3+CPhcvoo8xCVLQ0WhIPpCupQcIl3djKHNy5iaEqPUTAL0GiL1wIgKCXge4pabOHwOVX7wfgB0/e5iuBQH4+NAGXzgRsGajsMoHyDhrdDibgT7Zdy5EQDID2w4tmLgKQFiSyW2Ux2Qck3FMjsk4JuOYjGMyjskxGcdkHJNxTMYxOSbjmIxjMo7JMRnHZByTcUzGMTkm45iMYzKOyTgmx2Qck3FMxjE5JuOYjGMyjsk4JsdkHJNxTMYxGcfkmIxjMo7JOCbH5Jgck3FMxjEZx+SYjGMyjsk4JuOYHJNxTMYxGcdkHJNjMo7JOCbjmByTcUzGMRnHZByTYzKOyTgm45iMY3JMxjEZx2Qck2Myjsk4JuOYjGNyTMYxGcdkHJNxTI7JOCbjmIxjckzGMRnHZByTcUyOyUZDTGL/ZziNOXyMv2YZx2Qck2Myjsk4JuOYjGNyTMYxGcdkHJNjMo7JOCbjmIxjckzGMRnHZByTcUyOyWYffFinWPJTJ+AfGFJuv2mzlf+42Rv/LHJzEFzlnh3OMf8rTL5JvdoPe8EJ3Yl26ii+dfdpFzXu0eAfJHSREg9nNKd+ycvLK9gOuD3rqM5bPd71mBrR3wsDuRvwFjdP/M0YHUa9BVayHY8O0AaZrvfQ4yAMaUop/bHSE8LYhBIqGgenAm2URxanLQuVbkVROskN+I6ImuvGuxrT/c1cbC/BQItq8ZbvSrXoExD7+Q/LENXkhlEuop1uBgC+azXArFf0yhdDmGhRUtBHe5CejIUzlylnPT2BEwvqKSk+Pj5jKgKOVCrURS2XXY2ZUKVFyT70iU1KSjrZLIZFHj+lQpVJRWelVQBKiMpOz8PhXIxyPtV0FkIiRUAkfUw3MYT8nk8xwG46DyeiqC2knOLhxIrWfKiC2jusf5ZT+0FPV2O+SMVCKn+qCgZ2Xrt27X67GPbfL/KB4Jdly9wrfN2+DcDMiQXrAZQ2lQu3MHp9Q0UaCB5RkIKaKBqDWk5n8Ja8nmkYkttT+jKRStycxmz5HVJkdWfpmgvUkQ64GHNtkzfu5mSVmiRd/9es4WmRNwDtTuvLaZBO5UB1T8SMt3y8YMGCMzcwammaKaJ3BlUa3cKgcrrG4y2RdAhD2k6vfSqp/qlUnOnmLGZ4mZI3Fouaz8DVmMbmx1j7l39iEVSeKVJWS0pKefuelBQ9zNZd3v8/2w/Y+1yW1uXm1j/KXVyzEktD8dNOjFrT6TGkJIttOST/rnYtBlNbhL+pK8SgJiYkJ1tpeTI5JDqJqSvufjZWFoKrMbUPmx4brBuQ+IeXoIHPVdUv3Z058jUIEAn9rlbF3X04GYJ78g7l++SILKA4ERURGLWW2T9eRtvT7gtQPaRxGIS25wr+prgCg9HbSPgdxhm9LtPXTmLubq0Kht1s12Kuerz9cVI+kEjSZ1AFHGjOCccAgQW2nW6wi6OLADQyph6j13raBmnGNNoLVQ5NxGBsd/A3Jc8xmAh6dKaMdsChnKKGjulZZtsJu/Nkdimm3/iNj2EQMYv9BU8A2tizbVR0QhoLSbc0p7NsxRwJws3KZ1mYWzemODH51nsQExn0ofOYT6vd8Ba9koPBRFImrtGn6DObasYMHdPc9NoTdrc7NrgQUxIxhb5nZuDVplpK3SntpkDA++sipbP1jaqKAER/d2/j3YwzN1GcOEnRj/qvWWgspXD6NYs9tAJv2UXxLsU8QKcxdMwf+v97q2Pdu8V8PleYCG3mvz4gLSSdjImzabPSc6CaSiJuqfHeer851q0iJoo3jf4F0Dq6+bnzBZDBVumLAYKb33i6FLOMop3EpJYVw46pWIQ9EELIUilZZEwpbUDMVVlya7KyI0DG3P3L6N+aPCIq83O6NcEGKvKHw6Sy7sVwJeZMqh3jJOblH92HHbMIfUIoPESaMVhMr0AZ86cLkDFDOv1G/aHBrobL45wdGkj76XUY7HRft/VshksxMykLTmJK/xUxjUHSFEfMV/tV3xIkEXNhGPAkETgZPPqP8yRnx3nSXopH7KrIKPPJGqpbDNdiltICDM7U+m8M9JsSP/yYdap6R8w351U3HDGBhHO04P04aJecHbRLy2hvLqkq0nzgWswZVOeGwX1ka7pysd8Vaoh1Mea8DAhR6ehj+N4Nkvv3vlDFbITKcBTS1ggAcZlr3PgKrD8m0dXVKTvMoXDiQ7qdUExZCXbX6FsM5W4zDdRexJfT/3OX08uoJAb/KLCHBuqYjiGZ9+zttyceHPN/7mcjC9O1cMGirAuXvrt4we5EJP8GiHFMjsk4JuOYjGNyTMYxGcdkHJNxTI7JOCbjmIxjMo7JMRnHZByTccz3PeaowUZRTPYfd0SdefRmvtAAAAAASUVORK5CYII=" style="width: 230px; height: 100px;"><div class="TemplateItem__Cover-byPKZG hRGmwL"><div class="block-vertical-layout block-align-center"><div style="margin-bottom: 15px;">专业版功能，开通即可使用</div><div><a class="pano-button pano-button-sm pano-button-primary" href="https://720yun.com/t/479jv0em5k3" target="_blank">预 览</a><a class="pano-button pano-button-sm pano-button-important" href="/vip" target="_blank" style="margin-left: 10px;">开 通</a></div></div></div></div></div></div></div>
                                                      <div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
                                                        <div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div>
                                                        <div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
                                                          <div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
                                                          <div class="SidePanel_footer_3WAcEI"><a class="pano-button pano-button-md pano-button-primary" style="width: 120px;">完 成</a></div></div>
    </div>
    <div v-if='type==5'>
        <div class="ReactModal__Content ReactModal__Content--after-open SidePanel_container_iLZTuc" tabindex="-1" role="dialog" aria-label="sidePanel">
          <div class="SidePanel_header_2aul_9">
            <div class="SidePanel_title_3lP_QU">自动巡游</div>
            <div class="SidePanel_close_3b1ufR">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAyUlEQVQ4y63UwQ3DIAwFUF9YInNkF1bINu2hc3SPrsAiGITiHtKQRDHwLZUbhycs+B8iIko+eQKXOH7IVLfJc+GCcXH8jsLhx5PnEiUKwjcapfIdj/lBlbP7XKUYb9Ix79I+H9I2h6jOYXrnJnrjHxO9cjO9cxMlEncaeM2LiR7XhFZGe9fVxK+Pkxe0cWok4MLqkYB4O01D3g9il48z3ORY/FWON0fh/MQzfOZ5JiKZOODxr7/8ax984oA3J3kulW7cUro80z/WFy2VcKz02EA2AAAAAElFTkSuQmCC" class="SidePanel_imgClose_2a2S-Y"></div></div>
              <div class="SidePanel_body_1nZuJv">
                <div class="SidePanel_bodyContainer_1iszVS">
                  <div style="position: relative; overflow: hidden; width: 100%; height: 100%;">
                    <div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;">
                      <div class="SidePanelAutoPlay_container_1i--hO">
                        <div class="SidePanelAutoPlay_group_3EUJ5U">
                          <div>自动巡游</div>
                          <img src="../assets/active.png" class="ToggleIcon_root_2QoX04" alt=""></div>
                          <div><div class="SidePanelAutoPlay_group_3EUJ5U">场景旋转时间<div>3分钟</div></div>
                          <div class="rc-slider">
                            <div class="rc-slider-rail" style="background-color: rgb(43, 43, 43); border: 1px solid rgb(67, 67, 67); border-radius: 0px;"></div>
                            <div class="rc-slider-track" style="background-color: rgb(65, 121, 249); border: 1px solid rgb(67, 67, 67); border-radius: 0px; left: 0%; width: 45.4545%;"></div>
                            <div class="rc-slider-step"></div><div tabindex="0" class="rc-slider-handle" role="slider" aria-valuemin="30" aria-valuemax="360" aria-valuenow="180" aria-disabled="false" style="border: 1px solid rgb(255, 255, 255); background-color: rgb(223, 223, 223); left: 45.4545%;"></div><div class="rc-slider-mark"></div></div><div class="SidePanelAutoPlay_group_3EUJ5U"><div class="SidePanelAutoPlay_num_1n7hWu">30秒</div><div class="SidePanelAutoPlay_num_1n7hWu">6分钟</div></div><div class="SidePanelAutoPlay_group_3EUJ5U">
                              <div>旋转一圈自动跳转下一场景</div>
                              <div class="Checkbox_container_jYKPxJ">
                                <div class="Checkbox_checkbox_2hIu2H Checkbox_checked_3yFHX3" style="width: 14px; height: 14px;"><span class="SVGInline">
                                  <svg class="SVGInline-svg" fill="#fff" style="width: 10px;height: 10px;" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.146 0l-4.36 4.39L.81 2.412 0 3.371l2.757 2.756L8 .854z" fill-rule="evenodd"></path></svg></span></div></div></div></div></div></div>
                                  <div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
                                    <div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div>
                                    <div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
                                      <div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
                                      <div class="SidePanel_footer_3WAcEI"><a class="pano-button pano-button-md pano-button-primary SidePanelAutoPlay_btn_1pj1EA">完 成</a></div></div>
    </div>
    <div v-if='type==6'>
      <div class="ReactModal__Content ReactModal__Content--after-open SidePanel_container_iLZTuc" tabindex="-1" role="dialog" aria-label="sidePanel">
        <div class="SidePanel_header_2aul_9">
          <div class="SidePanel_title_3lP_QU">说一说</div>
          <div class="SidePanel_close_3b1ufR">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAyUlEQVQ4y63UwQ3DIAwFUF9YInNkF1bINu2hc3SPrsAiGITiHtKQRDHwLZUbhycs+B8iIko+eQKXOH7IVLfJc+GCcXH8jsLhx5PnEiUKwjcapfIdj/lBlbP7XKUYb9Ix79I+H9I2h6jOYXrnJnrjHxO9cjO9cxMlEncaeM2LiR7XhFZGe9fVxK+Pkxe0cWok4MLqkYB4O01D3g9il48z3ORY/FWON0fh/MQzfOZ5JiKZOODxr7/8ax984oA3J3kulW7cUro80z/WFy2VcKz02EA2AAAAAElFTkSuQmCC" class="SidePanel_imgClose_2a2S-Y"></div></div><div class="SidePanel_body_1nZuJv">
              <div class="SidePanel_bodyContainer_1iszVS">
                <div style="position: relative; overflow: hidden; width: 100%; height: 100%;">
                  <div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;">
                    <div class="SidePanelComments_container_q4yjad">
                      <div class="SidePanelComments_header_Ko5ruA">
                        <div class="SidePanelComments_title_2TwXyt">说一说功能</div>
                        <img src="../assets/active.png" class="ToggleIcon_root_2QoX04" alt=""></div>
                        <div class="SidePanelComments_tip_1JhHG1">关闭该功能后，所有人都不能对作品发表说一说</div>
                        <div class="SidePanelComments_header_Ko5ruA"><div class="SidePanelComments_title_2TwXyt">说一说内容</div>
                        <img src="../assets/active.png" class="ToggleIcon_root_2QoX04" alt=""></div>
                        <div class="SidePanelComments_tip_1JhHG1">关闭该功能后，浏览作品时说一说内容默认隐藏</div></div></div>
                        <div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
                          <div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div>
                          <div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
                            <div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
                            <div class="SidePanel_footer_3WAcEI"><a class="pano-button pano-button-md pano-button-primary SidePanelComments_btn_24RBSM">完 成</a></div></div>
    </div>
    <div v-if='type==7'>
       <div class="ReactModal__Content ReactModal__Content--after-open SidePanel_container_iLZTuc" tabindex="-1" role="dialog" aria-label="sidePanel">
         <div class="SidePanel_header_2aul_9">
           <div class="SidePanel_title_3lP_QU">手机陀螺仪</div>
           <div class="SidePanel_close_3b1ufR">
             <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAyUlEQVQ4y63UwQ3DIAwFUF9YInNkF1bINu2hc3SPrsAiGITiHtKQRDHwLZUbhycs+B8iIko+eQKXOH7IVLfJc+GCcXH8jsLhx5PnEiUKwjcapfIdj/lBlbP7XKUYb9Ix79I+H9I2h6jOYXrnJnrjHxO9cjO9cxMlEncaeM2LiR7XhFZGe9fVxK+Pkxe0cWok4MLqkYB4O01D3g9il48z3ORY/FWON0fh/MQzfOZ5JiKZOODxr7/8ax984oA3J3kulW7cUro80z/WFy2VcKz02EA2AAAAAElFTkSuQmCC" class="SidePanel_imgClose_2a2S-Y"></div></div>
             <div class="SidePanel_body_1nZuJv">
               <div class="SidePanel_bodyContainer_1iszVS">
                 <div style="position: relative; overflow: hidden; width: 100%; height: 100%;">
                   <div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;">
                     <div class="SidePanelGyroscope_container1_1Mhq63">
                       <div class="SidePanelGyroscope_row_136kfw">陀螺仪图标<img src="../assets/active.png" class="ToggleIcon_root_2QoX04" alt=""></div>
                       <div class="SidePanelGyroscope_tip_2_iaJK">开启后将在作品中显示陀螺仪图标</div></div>
                       <div style="width: 100%; height: 2px; border-top: 1px solid rgb(0, 0, 0); border-bottom: 1px solid rgb(75, 75, 75);"></div>
                       <div class="SidePanelGyroscope_container2_9ZGhKx">
                         <div class="SidePanelGyroscope_row_136kfw">手机陀螺仪功能<img src="../assets/noactive.png" class="ToggleIcon_root_2QoX04" alt=""></div>
                         <div class="SidePanelGyroscope_tip_2_iaJK">开启后作品将默认启用陀螺仪功能</div></div></div>
                         <div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
                           <div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div>
                           <div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
                             <div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
                             <div class="SidePanel_footer_3WAcEI"><a class="pano-button pano-button-md pano-button-primary SidePanelGyroscope_btn_2xRKBo">完 成</a></div></div>
    </div>
    <div v-if='type==0'>
      <div class="ReactModal__Content ReactModal__Content--after-open SidePanel_container_iLZTuc" tabindex="-1" role="dialog" aria-label="sidePanel">
        <div class="SidePanel_header_2aul_9"><div class="SidePanel_title_3lP_QU">作品标签</div>
        <div class="SidePanel_close_3b1ufR" @click='close'>
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAQAAACROWYpAAAAyUlEQVQ4y63UwQ3DIAwFUF9YInNkF1bINu2hc3SPrsAiGITiHtKQRDHwLZUbhycs+B8iIko+eQKXOH7IVLfJc+GCcXH8jsLhx5PnEiUKwjcapfIdj/lBlbP7XKUYb9Ix79I+H9I2h6jOYXrnJnrjHxO9cjO9cxMlEncaeM2LiR7XhFZGe9fVxK+Pkxe0cWok4MLqkYB4O01D3g9il48z3ORY/FWON0fh/MQzfOZ5JiKZOODxr7/8ax984oA3J3kulW7cUro80z/WFy2VcKz02EA2AAAAAElFTkSuQmCC" class="SidePanel_imgClose_2a2S-Y"></div></div><div class="SidePanel_body_1nZuJv"><div class="SidePanel_bodyContainer_1iszVS"><div style="position: relative; overflow: hidden; width: 100%; height: 100%;">
            <div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;"><div>
              <div class="SidePanelTags_group_21abQR"><div class="SidePanelTags_title_hUF15Y">系统推荐标签</div>
              <div class="SidePanelTags_tagList_AgKRaq">
                <span class="Tag_tag_1kGAJC" v-for='(item,i) in items' @click='chooseitem(item)'><span class="Tag_name_1C-Gla ellipsis">{{item}}</span></span>
              </div></div>
                      <div class="SidePanelTags_group_21abQR">
                        <div class="SidePanelTags_title_hUF15Y">自定义标签</div><div class="SidePanelTags_customTag_2GHyen">
                          <input type="text" class="pano-input pano-input-md pano-input-dark SidePanelTags_input_2eKOyY" placeholder="输入自定义标签" value="" v-model='diy' />
                          <a class="pano-button pano-button-sm pano-button-primary SidePanelTags_btn_14BsQV" @click='create'>创 建</a></div></div>
                          <div style="width: 100%; height: 2px; border-top: 1px solid rgb(0, 0, 0); border-bottom: 1px solid rgb(75, 75, 75);"></div>
                          <div class="SidePanelTags_group_21abQR"><div class="SidePanelTags_title_hUF15Y">已添加标签</div><div class="SidePanelTags_tagList_AgKRaq">
                          
                              <span class="Tag_tag_1kGAJC" v-for='(item,i) in items1' @click='del(i)'><span class="Tag_name_1C-Gla ellipsis">{{item}}</span><div class="Tag_icon_3ZSbmb"><svg width="6" height="6"><path d="M.587 0l2.42 2.42L5.412 0 6 .587 3.58 2.994 6 5.414 5.413 6 3.006 3.58.586 6 0 5.413l2.432-2.42L0 .588z" fill="#FFF" fill-rule="nonzero"></path></svg></div></span>
                             

                                </div></div></div></div>
                                <div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;"><div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div><div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;"><div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div></div></div></div></div>
                                <div class="SidePanel_footer_3WAcEI"><a class="pano-button pano-button-md pano-button-primary SidePanelTags_btnConfirm_3fVEBi" @click='savelabel'>完 成</a></div></div>
    </div>
  </div>
</template>
<style scoped>
.SidePanelTags_group_21abQR {
    padding: 0 15px;
    margin-top: 30px;
    margin-bottom: 30px;
}
.SidePanelTags_title_hUF15Y {
    margin-bottom: 10px;
}
.SidePanelTags_tagList_AgKRaq {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    font-size: 12px;
    margin-left: -10px;
}
.Tag_tag_1kGAJC {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 20px;
    padding: 0 10px;
    margin-top: 10px;
    margin-left: 10px;
    background-color: #777;
    border-radius: 3px;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
}
.Tag_name_1C-Gla {
    max-width: 140px;
}
.SidePanelTags_group_21abQR {
    padding: 0 15px;
    margin-top: 30px;
    margin-bottom: 30px;
}
.SidePanelTags_customTag_2GHyen {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
input[type="text"], input[type="password"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-left: 10px;
    padding-right: 10px;
    color: #333;
    border: #e9e9e9 1px solid;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.SidePanelTags_btn_14BsQV {
    width: 60px;
    padding: 0;
}
.pano-button-primary {
    background-color: #286efa;
    color: #fff;
}
.pano-button-sm {
    height: 30px;
}
.SidePanelTags_group_21abQR {
    padding: 0 15px;
    margin-top: 30px;
    margin-bottom: 30px;
}
.SidePanelTags_title_hUF15Y {
    margin-bottom: 10px;
}
.SidePanelTags_tagList_AgKRaq {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    font-size: 12px;
    margin-left: -10px;
}
.Tag_tag_1kGAJC {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 20px;
    padding: 0 10px;
    margin-top: 10px;
    margin-left: 10px;
    background-color: #777;
    border-radius: 3px;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
}
.Tag_name_1C-Gla {
    max-width: 140px;
}
.ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    min-height: 1em;
}
input[type="text"], input[type="password"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-left: 10px;
    padding-right: 10px;
    color: #333;
    border: #e9e9e9 1px solid;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.SidePanelTags_btn_14BsQV {
    width: 60px;
    padding: 0;
}
.SidePanelTags_input_2eKOyY {
    width: 155px;
}
.pano-input-md {
    height: 34px;
}
.pano-input-dark {
    background-color: #2c2c2c;
    border-color: #525252!important;
    color: #fff!important;
}
.pano-button {
  white-space: nowrap;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 3px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}
.SidePanelTags_customTag_2GHyen {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.ProjectForm_root_3kYeyn, .Tag_icon_3ZSbmb {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.Tag_icon_3ZSbmb {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-left: 5px;
}
.SidePanel_body_1nZuJv {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 auto;
    flex: 1 auto;
    border-bottom: 1px solid #000;
    border-top: 1px solid #4b4b4b;
}
.SidePanelGyroscope_container1_1Mhq63 {
    padding: 30px 15px 20px;
}
.SidePanelGyroscope_tip_2_iaJK {
    margin-top: 10px;
    color: #777;
    line-height: 20px;
}
.SidePanelGyroscope_row_136kfw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.SidePanelGyroscope_container2_9ZGhKx {
    padding: 20px 15px;
}
.SidePanelGyroscope_row_136kfw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
*{
  text-align: left;
}
.SidePanelComments_container_q4yjad {
    padding: 30px 15px 0;
}
.SidePanelComments_header_Ko5ruA {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 10px;
}
.SidePanelComments_title_2TwXyt {
    color: #fff;
}
.ToggleIcon_root_2QoX04 {
    width: 40px;
    height: 20px;
    cursor: pointer;
}
.SidePanelComments_tip_1JhHG1 {
    margin-bottom: 35px;
    color: #777;
    line-height: 20px;
}
.SidePanelComments_header_Ko5ruA {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 10px;
}
.SidePanelComments_tip_1JhHG1 {
    margin-bottom: 35px;
    color: #777;
    line-height: 20px;
}
.SidePanelAutoPlay_container_1i--hO {
    padding: 30px 15px 0;
}
.SidePanelAutoPlay_group_3EUJ5U {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 30px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.ToggleIcon_root_2QoX04 {
    width: 40px;
    height: 20px;
    cursor: pointer;
}
.SidePanelAutoPlay_group_3EUJ5U {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 30px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.Checkbox_checked_3yFHX3 {
    background-color: #427afb;
    border-color: #427afb;
}
.rc-slider {
    position: relative;
    height: 14px;
    padding: 5px 0;
    width: 100%;
    border-radius: 6px;
    -ms-touch-action: none;
    touch-action: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #e9e9e9;
    height: 4px;
    border-radius: 6px;
}
.rc-slider-track {
    position: absolute;
    left: 0;
    height: 4px;
    border-radius: 6px;
    background-color: #abe2fb;
}
.hRGmwL {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
}
.SidePanelOpening_container_2qXr4D {
    padding: 30px 15px 20px;
}
.SidePanelOpening_row_1Rm0Gq {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 20px;
}
.ToggleIcon_root_2QoX04 {
    width: 40px;
    height: 20px;
    cursor: pointer;
}
.HelpIcon_root_WFV-sl {
    width: 18px;
    height: 18px;
}

.pano-button-important {
    background-color: #db4437;
    color: #fff;
}
.BusinessFeature_container_3iMptY {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column;
    flex-flow: column;
    margin-top: 10px;
    padding: 20px 0;
    background-color: #50565c;
}
.BusinessFeature_text_3aU27K {
    color: #fff;
    margin-top: 5px;
    margin-bottom: 20px;
}
.BusinessFeature_btn_2eZ2Lp {
    width: 120px;
}
.BusinessFeature_url_13slbU {
    margin-top: 15px;
}
.SidePanelStartImage_imgContainer_107-s9 {
    height: 190px;
}
.ContentBox_box_18qEQ3 {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #2c2c2c;
    color: #aaa;
    border: 1px solid #4b4b4b;
    border-radius: 3px;
} 
.SidePanelStartImage_row_153qEM {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.SidePanelStartImage_tip_1vNm9e {
    line-height: 15px;
    color: #aaa;
}
.SidePanelStartImage_mobile_21eXlC {
    border-top: 1px solid #4b4b4b;
    border-bottom: 1px solid #000;
}
.SidePanelStartImage_title_1NJT_P {
    margin-bottom: 10px;
}
.SidePanelStartImage_imgContainer_107-s9 {
    height: 190px;
}
.ContentBox_box_18qEQ3 {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #2c2c2c;
    color: #aaa;
    border: 1px solid #4b4b4b;
    border-radius: 3px;
}
.SidePanelStartImage_row_153qEM {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.SidePanelStartImage_footer_vgA79N {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 10px;
}
.SidePanelStartImage_tip_1vNm9e {
    line-height: 15px;
    color: #aaa;
}
.SidePanelStartImage_group_2i-4Oa {
    padding: 30px 15px;
}
.SidePanelStartImage_row_153qEM {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.SidePanelStartImage_tipTime_2YPTeC {
    color: #aaa;
}
.rc-slider {
    position: relative;
    height: 14px;
    padding: 5px 0;
    width: 100%;
    border-radius: 6px;
    -ms-touch-action: none;
    touch-action: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #e9e9e9;
    height: 4px;
    border-radius: 6px;
}
.rc-slider-track {
    position: absolute;
    left: 0;
    height: 4px;
    border-radius: 6px;
    background-color: #abe2fb;
}
.rc-slider * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rc-slider-handle {
    position: absolute;
    margin-left: -7px;
    margin-top: -5px;
    width: 14px;
    height: 14px;
    cursor: pointer;
    cursor: -webkit-grab;
    cursor: grab;
    border-radius: 50%;
    border: solid 2px #96dbfa;
    background-color: #fff;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
}
.rc-slider-mark {
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
    font-size: 12px;
}
.SidePanelStartImage_sec_2Ji51Q {
    color: #aaa;
    font-size: 12px;
    margin-top: 10px;
}
.SidePanelStartImage_row_153qEM {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.SidePanelStartImage_sec_2Ji51Q {
    color: #aaa;
    font-size: 12px;
    margin-top: 10px;
}
.SidePanel_container_iLZTuc {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    width: 260px;
    -webkit-box-shadow: 0 2px 10px 0 rgba(0,0,0,.5);
    box-shadow: 0 2px 10px 0 rgba(0,0,0,.5);
    background-color: #333;
    color: #fff;
    -webkit-animation-name: SidePanel_slideInRight_2Mnn_J;
    animation-name: SidePanel_slideInRight_2Mnn_J;
    -webkit-animation-duration: .3s;
    animation-duration: .3s;
}
.SidePanel_header_2aul_9 {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 40px;
    flex: 0 0 40px;
    border-bottom: 1px solid #000;
}
.SidePanel_header_2aul_9, .SidePanel_title_3lP_QU {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
}
.SidePanel_title_3lP_QU {
    -webkit-box-flex: 1;
    -ms-flex: 1 auto;
    flex: 1 auto;
    padding-left: 15px;
    font-size: 16px;
    -ms-flex-align: center;
}
.SidePanel_title_3lP_QU {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
}
.SidePanel_close_3b1ufR {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 35px;
    height: 35px;
    cursor: pointer;
}
.SidePanel_imgClose_2a2S-Y {
    width: 12px;
    height: 12px;
}
.SidePanel_body_1nZuJv {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 auto;
    flex: 1 auto;
    border-bottom: 1px solid #000;
    border-top: 1px solid #4b4b4b;
}
.SidePanel_bodyContainer_1iszVS {
    position: absolute;
    width: 100%;
    height: 100%;
}
.SidePanelStartImage_pc_2tEyQ9 {
    border-bottom: 1px solid #000;
}
.SidePanelStartImage_title_1NJT_P {
    margin-bottom: 10px;
}
.SidePanel_footer_3WAcEI {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 15px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 65px;
    flex: 0 0 65px;
    border-top: 1px solid #4b4b4b;
}
.SidePanelStartImage_btn_1afHfU {
    width: 120px;
}
.pano-button-md {
    height: 34px;
}
.pano-button-primary {
    background-color: #286efa;
    color: #fff;
}
.pano-button {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 3px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}
  .rightBar{
    -ms-flex: 0 0 230px;
    flex: 0 0 230px;
    width: 230px;
    height: 100%;
    position: absolute;
    -webkit-box-flex: 0;
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    background-color: #333;
    color: #fff;
   
  }
.SidePanel_container_iLZTuc{
    right: -245px;
    -webkit-animation: slide 0.5s forwards;
    animation: slide 0.5s forwards;
}
@keyframes slide {
    100% { right: 0; }
}
</style>
<script>
function quchong(arr){
    var arr2 = [];
for(var i = 0;i< arr.length;i++){
    if(arr2.indexOf(arr[i]) < 0){
        arr2.push(arr[i]);
    }
   
}
 return arr2
}
export default {
  name: '',
  components: {
  },
  props:['labels'],
  data() {
    return {
        type:0,
        items:['空中','地面','国外','5A景区','4A景区','春季','夏季','秋季','冬季','漫游'],
        items1:[],
        diy:'',
        itemAdd:[]
    }
  },
  created() {

  },
  mounted(){
    // this.items1 = this.labels
    for(var i=0;i<this.labels.length;i++){
            this.items1.push(this.labels[i])
        }
  },
  methods: {
      close(){
        this.$emit('close',false)
      },
      chooseitem(item){ 
        this.items1.push(item)
        this.items1 = quchong(this.items1)
      },
      del(i){
        this.items1.splice(i,1)
      },
      create(){
        if(this.diy==''){
          this.$message('输入的标签不能为空');
        }
        else{
          this.items1.push(this.diy)
        }
      },
      savelabel(){
        var b = []
        
        for(var i=0;i<this.items1.length;i++){
            b[i] = this.items1[i]
        }
        this.$emit('label',b)
        
      }
  }
}
</script>
